import * as React from 'react';
import { Typography, Box } from '@mui/material';
import { connect } from "react-redux";
import { forgotPassword } from '../../app/store/actions/authActions';
import { Navigate, useNavigate } from "react-router-dom";
import { MainInput } from '../../app/components/Styles';
import { MarketingFormPage, MarketingButton } from '../../app/components/marketing';

export const ForgotPassword = ({ forgotPassword, user, token, isLoading }) => {
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        forgotPassword({ email: data.get('email') }, navigate);
    };

    if (user) {
        return (<Navigate to={`/${token.split(" ")[0]}`} replace />);
    }

    return (
        <MarketingFormPage
            maxWidth="sm"
            title="Forgot password?"
            subtitle="Enter your email and we'll send you a link to reset your password"
            loading={isLoading}
        >
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
                <MainInput
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    autoFocus
                />
                <MarketingButton type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>
                    Send reset link
                </MarketingButton>
            </Box>
        </MarketingFormPage>
    );
};

const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    isLoading: state?.wait?.isLoading,
    token: state?.auth?.token,
});

const mapDispatchToProps = { forgotPassword };

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
